import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { ROLES, RoutingList } from "../constants";
import LoginContainer from "./modules/login/Login";
import EcMembersContainer from "./modules/EcMembers";
import ForgotPassword from "./modules/login/forgotPassword";
import IRBSubmissionsContainer from "./modules/IRB/IRBSubmission";
import EthicsCommittee from "./modules/EthicsCommitee/EthicsCommittee";
import CreateECMemberContainer from "./modules/EcMembers/CreateECMember";
import CreateIRBSubmissionContainer from "./modules/IRB/IRBSubmission/CreateIRBSubmission";
import PrivateRoutes from "./PrivateRoute";
import RestrictedRoutes from "./RestrictedRoute";
import useAuthStore from "../states/zustand/authStore";
import IRBDetails from "./modules/IRB/IRBDetails/IRBDetails";
import Profile from "./modules/Profile/Profile";
import ProfileEdit from "./modules/Profile/ProfileEdit/ProfileEdit";
// import ChangePassword from "./modules/Profile/ChangePassword/ChangePasswordOld";
import ECSubmissionDetails from "./modules/EthicsCommitee/ECSubmissionDetails/ECSubmissionDetails";
import ChangePassword from "./modules/Profile/ChangePassword/ChangePassword";
import ECSubmissionsContainer from "./modules/EthicsCommitee";
import MemberPreview from "./modules/EcMembers/MemberPreview/MemberPreview";
import ECInitialReviewDetails from "./modules/EthicsCommitee/ECSubmissionDetails/ECInitialReviewDetails/ECInitialReviewDetails";
import IRBAdditionalSubmissionsContainer from "./modules/IRB/IRBAdditionalSubmission";
import CreateIRBAdditionalSubmissionContainer from "./modules/IRB/IRBAdditionalSubmission/CreateIRBAdditionalSubmission";
import Meeting from "./modules/Meeting/Meeting";
import MeetingDetails from "./modules/Meeting/MeetingDetails/MeetingDetails";
import CreateNewMeetingContainer from "./modules/Meeting/CreateMeeting/MeetingDetails";
import CreateAndUpdateMeetingContainer from "./modules/Meeting/CreateMeeting";

const Routing = () => {
  const {
    profileData: { role },
  } = useAuthStore();

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={RoutingList.pageNotFound.path}
          element={<h1>Not found</h1>}
        />
        <Route element={<RestrictedRoutes />}>
          <Route
            path={RoutingList.login.index.path}
            element={<LoginContainer />}
          />
          <Route
            path={RoutingList.login.forgot_password.path}
            element={<ForgotPassword />}
          />
        </Route>

        <Route element={<PrivateRoutes roles={RoutingList.index.permissios} />}>
          <Route
            path={RoutingList.index.path}
            element={
              <Navigate
                to={
                  role === ROLES.ECS
                    ? RoutingList.members.index.path
                    : role === ROLES.INVESTIGATOR
                    ? RoutingList.irb.index.path
                    : role === ROLES.MIRB
                    ? RoutingList.irb.index.path
                    : role === ROLES.MSMC
                    ? RoutingList.ethics_committee.index.path
                    : RoutingList.ethics_committee.index.path
                }
                replace
              />
            }
          />
        </Route>

        <Route
          element={
            <PrivateRoutes roles={RoutingList.members.index.permissios} />
          }
        >
          <Route
            path={RoutingList.members.index.path}
            element={<EcMembersContainer />}
          />
        </Route>
        <Route
          element={
            <PrivateRoutes roles={RoutingList.members.create.permissios} />
          }
        >
          <Route
            path={RoutingList.members.create.path}
            element={<CreateECMemberContainer />}
          />
        </Route>
        <Route
          element={
            <PrivateRoutes roles={RoutingList.members.edit.permissios} />
          }
        >
          <Route
            path={RoutingList.members.edit.path}
            element={<CreateECMemberContainer />}
          />
        </Route>
        <Route
          element={
            <PrivateRoutes roles={RoutingList.members.details.permissios} />
          }
        >
          <Route
            path={RoutingList.members.details.path}
            element={<MemberPreview />}
          />
        </Route>
        <Route
          element={<PrivateRoutes roles={RoutingList.irb.index.permissios} />}
        >
          <Route
            path={RoutingList.irb.index.path}
            element={<IRBSubmissionsContainer />}
          />
        </Route>

        <Route
          element={<PrivateRoutes roles={RoutingList.irb.details.permissios} />}
        >
          <Route path={RoutingList.irb.details.path} element={<IRBDetails />} />
        </Route>

        <Route
          element={<PrivateRoutes roles={RoutingList.irb.edit.permissios} />}
        >
          <Route
            path={RoutingList.irb.edit.path}
            element={<CreateIRBSubmissionContainer />}
          />
        </Route>
        {/* **************************** */}
        <Route
          element={
            <PrivateRoutes roles={RoutingList.irbAdditional.index.permissios} />
          }
        >
          <Route
            path={RoutingList.irbAdditional.index.path}
            element={<IRBAdditionalSubmissionsContainer />}
          />
        </Route>
        <Route
          element={<PrivateRoutes roles={RoutingList.irbAdditional.create.permissios} />}
        >
          <Route
            path={RoutingList.irbAdditional.create.path}
            element={<CreateIRBAdditionalSubmissionContainer />}
          />
        </Route>
        {/* ******************************* */}
        <Route
          element={
            <PrivateRoutes roles={RoutingList.profile.index.permissios} />
          }
        >
          <Route path={RoutingList.profile.index.path} element={<Profile />} />
        </Route>

        <Route
          element={
            <PrivateRoutes roles={RoutingList.profile.edit.permissios} />
          }
        >
          <Route
            path={RoutingList.profile.edit.path}
            element={<ProfileEdit />}
          />
        </Route>
        <Route
          element={
            <PrivateRoutes roles={RoutingList.profile.password.permissios} />
          }
        >
          <Route
            path={RoutingList.profile.password.path}
            element={<ChangePassword />}
          />
        </Route>
        <Route
          element={<PrivateRoutes roles={RoutingList.irb.create.permissios} />}
        >
          <Route
            path={RoutingList.irb.create.path}
            element={<CreateIRBSubmissionContainer />}
          />
        </Route>
        <Route
          element={
            <PrivateRoutes
              roles={RoutingList.irb.createNotification.permissios}
            />
          }
        >
          <Route
            path={`${RoutingList.irb.createNotification.path}/:id`}
            element={<CreateIRBSubmissionContainer />}
          />
        </Route>
        <Route
          element={
            <PrivateRoutes
              roles={RoutingList.ethics_committee.index.permissios}
            />
          }
        >
          <Route
            path={RoutingList.ethics_committee.index.path}
            element={<ECSubmissionsContainer />}
          />
        </Route>
        <Route
          element={
            <PrivateRoutes
              roles={RoutingList.ethics_committee.create.permissios}
            />
          }
        >
          <Route
            path={RoutingList.ethics_committee.create.path}
            element={<EthicsCommittee />}
          />
        </Route>
        <Route
          element={
            <PrivateRoutes
              roles={RoutingList.ethics_committee.details.permissios}
            />
          }
        >
          <Route
            path={RoutingList.ethics_committee.details.path}
            element={<ECInitialReviewDetails />}
          />
        </Route>
        <Route element={<PrivateRoutes roles={RoutingList.meeting.index.permissios}/>}>
          <Route path={RoutingList.meeting.index.path} element={<Meeting/>}/>
        </Route>
        <Route element={<PrivateRoutes roles={RoutingList.meeting.create.permissios}/>}>
          <Route path={RoutingList.meeting.create.path} element={<CreateAndUpdateMeetingContainer/>}/>
        </Route>
        <Route element={<PrivateRoutes roles={RoutingList.meeting.edit.permissios}/>}>
          <Route path={RoutingList.meeting.edit.path} element={<CreateAndUpdateMeetingContainer/>}/>
        </Route>
        <Route element={<PrivateRoutes roles={RoutingList.meeting.details.permissios}/>}>
          <Route path={RoutingList.meeting.details.path} element={<MeetingDetails/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Routing;
